export { default } from './CloseCircleOutline'
